import { render, staticRenderFns } from "./GlobalAlerts.vue?vue&type=template&id=79af2406&scoped=true&"
import script from "./GlobalAlerts.vue?vue&type=script&lang=ts&"
export * from "./GlobalAlerts.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalAlerts.vue?vue&type=style&index=0&id=79af2406&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af2406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
